<template>
  <div class="tablelist">
    <div class="row align--center">
      <div class="flex xs12 md6">
        <va-input :value="term" placeholder="Buscar por programa" @input="search">
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
      <div class="flex xs12 md2">
        <va-select v-model="staActiveModel" textBy="description" placeholder="Estado " :options="this.staActive"
          @change="search" />
      </div>
      <div class="flex xs12 md2 offset--md2">
        <va-select v-model="perPage" :label="$t('tables.perPage')" :options="perPageOptions" />
      </div>
    </div>
    <va-data-table :fields="fields" :data="filteredData" :per-page="parseInt(perPage)"
      no-data-label="No se encuentran datos para esta busqueda">
      <div>
      </div>
      <template slot="staActive" slot-scope="props">
        <img class="imgdata ma-0" src="../../assets/images/user_check.png" width="20" title="Activo"
          v-if="props.rowData.staActive === true" />
        <img class="imgdata ma-0" src="../../assets/images/user_inactive.png" width="20" title="Inactivo" v-else />
      </template>
      <template slot="actions" slot-scope="props">
        <div v-for="item of fields[fields.length - 1].actionRef" :key="item.id">
          <template v-if="item.action === 'edit'">
            <img class="imgdata ma-0" :id="props.rowData.idProgram" src="../../assets/images/edit.png"
              alt="Editar Programa" title="Editar Programa" width="20" @click="dataProgram(props.rowData, item.action)" />
          </template>
        </div>
      </template>
    </va-data-table>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  data() {
    return {
      term: null,
      perPage: '20',
      perPageOptions: ['5', '10', '15', '20'],
      staActive: [
        {
          id: 1,
          description: 'Activo',
        },
        {
          id: 2,
          description: 'Inactivo',
        },
      ],
      staActiveModel: '',
      desPeriod: this.InfoView,
    }
  },
  props: {
    method: Function,
    InfoView: Array,
    HeadTable: Array,
  },
  computed: {
    fields() {
      return this.HeadTable
    },
    filteredData() {
      if (((!this.term) || (this.term.length < 1)) && (!this.staActiveModel.id)) {
        return this.desPeriod
      } else if (this.term) {
        return this.desPeriod.filter(item => {
          if (this.term && this.term.length >= 1) {
            return item.desPeriod.toLowerCase().startsWith(this.term.toLowerCase())
          }
        })
      } else {
        return this.desPeriod.filter(item => {
          switch (this.staActiveModel.id) {
            case 1:
              return item.staActive === true
            case 2:
              return item.staActive === false
            default:
              return item
          }
        })
      }
    },
  },
  methods: {
    dataProgram(user, ref) {
      this.method(user, ref)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
}
</script>

<style>
.tablelist .va-button {
  color: #222 !important;
  border-color: #222 !important;
}

.tablelist .va-button--active {
  color: #ffffff !important;
  border-color: #222 !important;
  background-color: #222 !important;
}

.tablelist .va-select__label {
  color: #222 !important;
}

.va-select__option--selected {
  color: #222 !important;
}

.tablelist .va-button--small .va-button__content__title {
  color: #222 !important;
}

.va-table th,
.content table th {
  border-bottom: 2px solid #222 !important;
  font-size: 12px !important;
}

.va-data-table__vuetable th.sortable {
  color: #222 !important;
}

.imgdata {
  cursor: pointer;
  margin-left: 2px !important;
  margin-right: 2px !important;
}
</style>
